import { defineStore } from "pinia";
import { useUsersStore } from "./user";

export const useCategoriesStore = defineStore("categories", {
  state: () => ({
    categories: [],
    apiUrl: "https://yowl-community.cf-host.com/api/",
    token: "",
  }),
  actions: {
    //---------------------------action sur Posts pour CRUD--------------------------------------
    createCategory(name) {
      const userStore = useUsersStore();
      const token = userStore.token;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        name: name,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${this.apiUrl}categories/create`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    getCategories() {
      var myHeaders = new Headers();

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(`${this.apiUrl}categories`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          this.categories = result.categories;
          console.log(this.categories.categories);
        })
        .catch((error) => console.log("error", error));
    },
  },
});
